import {MenuItem} from "../_components/layout/MobileMenu/MenuTypes";
import staticUrls from "./staticPageUrls";

/**
 * Constants used for the structure of the navbar and mobile menu.
 */

export const ACCOUNT_MENU_ID = "account-menu";

export const CART_NAV_ITEM_ID = "cart";

export const ABOUT_MENU_ITEMS = [
	{
		label: "Mathematics", // each item needs label, href, and id, but this comment is mostly here to make the formatter format this to multiple lines.
		href: staticUrls.mathCourses,
		id: "about-math",
	},
	{
		label: "Language Arts",
		href: staticUrls.languageArtsCourses,
		id: "about-la",
	},
	{
		label: "Science",
		href: staticUrls.scienceCourses,
		id: "about-sci",
	},
	{
		label: "Summer Camps",
		href: staticUrls.summerCamps,
		id: "about-summer",
	},
];

export const COURSE_MENU_ITEMS = [
	{
		label: "Academic Year Courses",
		href: staticUrls.academicYear,
		id: "ay-courses",
	},
	{
		label: "Summer Camps",
		href: staticUrls.summerCourses,
		id: "summer-courses",
	},
];

// When Summer courses are added, use this
// (to display multiple items under "Schedule" on navbar):
// export const SCHEDULE_MENU_ITEM: MenuItem = {
// 	label: "Schedule",
// 	id: "schedule",
// 	menuItems: [
// 		{
// 			label: "Academic Year Courses",
// 			href: staticUrls.classScheduleAY,
// 			id: "ay-courses",
// 			dynamicHref: "/campus/:campus/class-schedule?season=academic-year",
// 		},
// 		{
// 			label: "Summer Camps",
// 			href: staticUrls.classScheduleSummer,
// 			id: "summer-courses",
// 			dynamicHref: "/campus/:campus/class-schedule?season=summer",
// 		},
// 	],
// };

// When it's just academic year courses, use this
// (so that the Schedule menu item links to the schedule page for academic year course):
export const SCHEDULE_MENU_ITEM: MenuItem = {
	label: "Schedule",
	id: "schedule",
	href: staticUrls.classScheduleAY,
	dynamicHref: "/campus/:campus/class-schedule?season=academic-year",
};

export const TOP_LEVEL_MENU_ITEMS: MenuItem[] = [
	{
		label: "Our Programs",
		id: "our-programs",
		menuItems: ABOUT_MENU_ITEMS,
	},
	SCHEDULE_MENU_ITEM,
	{
		label: "Find a Campus",
		id: "locations",
		href: staticUrls.location,
	},
];
